import { NestedHierarchyNode } from "domains/nodes/services/node-service-helpers";
import NoPartitionsAllowedTooltip from "../no-partitions-allowed-tooltip/NoPartitionsAllowedTooltip";
import { StyledTreeItem } from "../styled-node-tree-item";

interface NodeTreeProps {
    nodes: NestedHierarchyNode[];
    showNoPartitionsAllowedTooltip?: boolean;
}

const renderTree = (node: NestedHierarchyNode, showNoPartitionsAllowedTooltip?: boolean) => (
    <StyledTreeItem extraLabel={!node.allowPartitionChildren && showNoPartitionsAllowedTooltip ? <NoPartitionsAllowedTooltip/> : <></>} key={node.id} nodeId={node.id.toString()} labelText={node.name}>
        {Array.isArray(node.children) ? node.children.map((node: any) => renderTree(node, showNoPartitionsAllowedTooltip)) : null}
    </StyledTreeItem>
);

const NodeTreeItem = (props: NodeTreeProps) => {
    return <>{Array.isArray(props.nodes) ? props.nodes.map((node: NestedHierarchyNode) => renderTree(node, props.showNoPartitionsAllowedTooltip)) : null}</>;
};

export default NodeTreeItem;
